import { createThunkWithError } from "../featureHelpers/errorParser";
import pushService from "./push.service";
export const API_URL_PUSH = `${import.meta.env.VITE_API_BASE_URL}notifications`;
const PUBLIC_VAPID_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY; // from .env or backend

export const connectWebPush = createThunkWithError<string, void>(
  "push/connectWebPush",
  async () => {
    const reg = await pushService.registerServiceWorker();

    if (!reg) {
      throw new Error(
        "Failed to register service worker for push notifications."
      );
    }

    const sessionWithSubscriptionId = await pushService.subscribeUserToPush(
      reg,
      PUBLIC_VAPID_KEY
    );

    return sessionWithSubscriptionId;
  }
);
